var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("PHYSICIAN, SURGEON, SPECIALIST, OR DOCTOR")]),_c('h4',[_vm._v("A person qualified by degree and duly licensed or registered to practice medicine in the geographical area in which he serves. This person must not be a relative of the Member up to the third degree of consanguinity and affinity.")])])
}]

export { render, staticRenderFns }